module.exports = __webpack_public_path__ + "img/1440333591.e835731c.jpg";